interface SectionAnchorData {
  anchor_id: string
}

export const fields = [
  "anchor_id",
]

interface SectionAnchorProps {
  data: SectionAnchorData
}

export default function SectionAnchor({ data }: SectionAnchorProps) {
  // Add null check for data.anchor_id to prevent the TypeError
  const anchorId = data?.anchor_id ? data.anchor_id.replace('#', '') : '';

  return (
    <div id={anchorId} className="-mt-36 pt-36 2xl:-mt-48 2xl:pt-48"></div>
  )
} 